import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { ApprovedTransaction } from "./transaction-views/approved-transaction";
import { PlanInstituciones } from "./planInstituciones";
import { PlanCasa } from "./planCasa";
import Error404 from "../404";

/**
 * Contenedor principal que contiene el enrutamiento de la tienda
 */
export const TiendaMakeMake = () => {


	return (
		<>
			<Switch>
				<Redirect exact from="/tienda/individual" to={"/tienda/plan-casa"} />
				<Redirect exact from="/tienda/cursos" to={"/tienda/plan-casa/aprender"} />
				<Route exact path="/tienda/plan-casa">
					<PlanCasa />
				</Route>
				<Route exact path="/tienda/plan-casa/:plan">
					<PlanCasa />
				</Route>

				<Redirect exact from="/tienda/institucional" to={"/tienda/institucional/cita"} />
				<Redirect exact from="/tienda/institucional/es/cita" to={"/tienda/institucional/cita"} />
				<Redirect exact from="/tienda/institucional/en/cita" to={"/tienda/institucional/cita"} />

				<Redirect exact from="/tienda/demo" to={"/contacto/demo"} />
				<Redirect exact from="/tienda/institucional/en/demo" to={"/contacto/demo"} />
				<Redirect exact from="/tienda/institucional/es/demo" to={"/contacto/demo"} />
				

				<Route
					exact
					path={["/tienda/institucional/cita", "/contacto/demo"]}
					render={() => <PlanInstituciones />}
				/>

				
				{/* <Redirect exact from="/tienda/brochure" to={"/tienda/institucional/es/brochure"} /> 
				<Redirect exact from="/tienda/institucional/brochure" to={"/tienda/institucional/es/brochure"} /> 
				<Route
					exact
					path={["/tienda/institucional/es/brochure", "/tienda/institucional/en/brochure"]}
					render={() => <PlanInstituciones />}
				/>

				<Redirect exact from="/tienda/contactanos" to={"/tienda/institucional/es/contactanos"} /> 
				<Redirect exact from="/tienda/institucional/contactanos" to={"/tienda/institucional/es/contactanos"} /> 
				<Route
					exact
					path={["/tienda/institucional/es/contactanos", "/tienda/institucional/en/contactanos"]}
					render={() => <PlanInstituciones />}
				/> */}

				<Route
					exact
					path="/tienda/compra/aprobada"
					component={ApprovedTransaction}
				/>
				<Redirect exact from="/tienda/" to={"/tienda/institucional"} />
				<Route component={Error404} />
			</Switch>
		</>
	);
};

